var req = require("!!/Users/admin/hogan/portfolio/node_modules/pug-loader/index.js!/Users/admin/hogan/portfolio/src/app/home-big-data/home-big-data.component.pug");
module.exports = (req['default'] || req).apply(req, [])